import { render, staticRenderFns } from "./IIcon.vue?vue&type=template&id=0cc7b5ff&functional=true&"
import script from "./IIcon.vue?vue&type=script&lang=js&"
export * from "./IIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports